import { defineComponent as _defineComponent } from 'vue'
import BCXTable from '@/components/BCXTable.vue';
import { computed, onMounted } from 'vue';
import useI18n from '@/mixins/useI18n';
import useFormattedDateTime from '@/mixins/useFormattedDateTime';

import useContract from '@/views/my-projects/composables/useContract';
import { ContractEvent } from '@/models/Contracts';
import { getDisplayName } from '@/utils/user';
import useUser from '@/mixins/useUser';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsContractChangeLogTable',
  setup(__props) {

const { userId } = useUser('self');
const { t } = useI18n();
const { contractEvents, fetchContractEvents, isContractEventsLoading } = useContract();
const { getFormattedTimeByAge } = useFormattedDateTime();

const sortableFields = ['eventTimestamp', 'message', 'from'];
const fields = ['eventTimestamp', 'message', 'from'];

const headerTitles = computed(() => [
  `${t('contracts.contract.contract-header.table.columns.time')}`,
  `${t('contracts.contract.contract-header.table.columns.change')}`,
  `${t('contracts.contract.contract-header.table.columns.from')}`
]);

const sortCallback = (fieldName: string, obj: ContractEvent) => {
  switch (fieldName) {
    case 'eventTimestamp':
      return getFormattedTimeByAge((obj.eventTimestamp ?? ''));
    case 'message':
      return obj.message;
    case 'from':
      return getDisplayName(obj.creator);
  }
  return 0;
};

const displayCallback = (fieldName: string, obj: any) => {
  switch (fieldName) {
    case 'eventTimestamp':
      return getFormattedTimeByAge((obj.eventTimestamp ?? ''));
    case 'message':
      return obj.message;
    case 'from':
      return obj.creator.userId === userId.value ? t('contracts.contract.contract-header.table.me') : getDisplayName(obj.creator);
  }
  return obj[fieldName];
};

onMounted(async () => {
  await fetchContractEvents();
});

return { __sfc: true,userId, t, contractEvents, fetchContractEvents, isContractEventsLoading, getFormattedTimeByAge, sortableFields, fields, headerTitles, sortCallback, displayCallback, BCXTable }
}

})